export default "__VITE_ASSET__ddefb2dd__"